<!-- src/components/Applications/AfsalSereign/Steps/Step5.vue -->
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import FileUpload from '@/components/Applications/Shared/FileUpload.vue'


const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
  changeSteps?: () => void // optional: if your parent listens to changes
}>()

// No required fields on this step, but we expose validate() for the wrapper
const rules = { }
const v$ = useVuelidate(rules, { })

function onChange() {
  props.changeSteps?.()
}

// Called by the wrapper before advancing
async function validate(): Promise<boolean> {
  await v$.value.$validate()
  return !v$.value.$error
}

defineExpose({ validate })
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_afsal_sereign_step5_header1') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <p class="forms__header m-t-20" style="font-size: 18px">
            {{ t('umsokn_afsal_sereign_step5_file_header') }}
          </p>
        </v-col>

        <v-col cols="12">
            <FileUpload
              :umsoknType="6"
              :umsoknId="umsokn.id"
              :filespace="5"
              :labelText="$t('umsokn_afsal_sereign_step5_file_header')"
              :disable="disable"
            />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-b-40 { margin-bottom: 40px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
.m-t-20 { margin-top: 20px; }
</style>
